import React from 'react'

import styles from './progressBar.module.scss'

type Props = {
  progress: number
  color?: string
  width?: number
  backgroundColor?: string
}

const ProgressBar = ({ progress, color = styles.x_primary_action, backgroundColor, width = 180 }: Props) => {
  const progressTranslate = -100 + progress
  return (
    <div className={styles['bar-base']} style={{ maxWidth: width + 'px', backgroundColor: backgroundColor }}>
      <div
        className={styles['bar-progress']}
        style={{ transform: `translateX(${progressTranslate}%)`, backgroundColor: color }}
      />
    </div>
  )
}

export default ProgressBar
